import React from 'react';
import { FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import SelectGroupProvider from '../../../../../dsasComponents/SelectGroupProvider.js';
import { discipline_all } from '../../../../../bdd/bddSTUB.js';
import { Can } from '../../../../../permissions/Can.js';
import { PERMISSIONS } from '../../../../../permissions/permissionKeys.js';
import { usePermissions } from '../../../../../permissions/usePermissions.js';


const PlayerSearch = ({ playerData, onChange, className }) => {

  const { getPermission } = usePermissions();
  const providerPermission = getPermission(PERMISSIONS.FILTER_PROVIDER);
  
  return (
    <>
    {/* Grid :
    xs, extra-small: 0px
    sm, small: 600px
    md, medium: 900px
    lg, large: 1200px
    xl, extra-large: 1536px 
    */}
        <Grid container spacing={1.5} sx={{alignItems : 'flex-end'}}>
            {providerPermission?.allowed && ( 
              <Grid item xs={12} sm={12} md>
                {/* Groupe de Fournisseurs */}
                <SelectGroupProvider value={playerData.provider} onChange={onChange} className={className}/>            
              </Grid>
            )}
            <Grid item xs={12} sm={12} md>
               {/* Nom */}
              <TextField
                className={className}
                name="lastname"
                label="Nom"
                error={!playerData.lastname}
                fullWidth
                value={playerData.lastname}
                onChange={onChange}
              />             
            </Grid>
            <Grid item xs={12} sm={12} md>
               {/* Prénom */}
              <TextField
                className={className}
                name="firstname"
                label="Prénom"
                fullWidth
                value={playerData.firstname}
                onChange={onChange}
              />              
            </Grid>
            <Grid item xs={12} sm={12} md>
               {/* Discipline */}
              <FormControl className={className} fullWidth error={!playerData.discipline}>
                <InputLabel>Discipline</InputLabel>
                <Select name="discipline" value={playerData.discipline} onChange={onChange} label="Discipline">
                  {discipline_all.map((discipline) => (
                    <MenuItem key={discipline._id} value={discipline._id}>
                      {discipline.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>              
            </Grid>
        </Grid>
    </>
  );
};

export default PlayerSearch;
